import * as _ from "lodash";

import * as angular from "angular";
import { CampaignDataProvider } from "../../data-provider/campaign.dp";
import { User } from "../../models/user.model";

let EssentialsDialogController = {
    selector: "essentialsDialog",
    templateUrl: "/angular/components/cancel/essentials-dialog.component.html",
    bindings: {
        currentUser: "=",
        selectedCampaign: "=",
    },
    controller: class EssentialsDialogController {
        // * bindings for typescript compiler *
        public currentUser: User;
        public selectedCampaign: string;
        // ************************************

        private $mdDialog;
        private campaignDataProvider: CampaignDataProvider;

        private selectedCampaignID: string | null = null;
        private campaigns = [];
        public __env: any;
        public selectedCampaigns = [];
        public step: number = 1;
        public restartDate;
        public showDateError: boolean = false;

        constructor(
            $mdDialog: any,
            CampaignDataProvider: CampaignDataProvider,
            __env: any
        ) {
            this.__env = __env;
            this.$mdDialog = $mdDialog;
            this.campaignDataProvider = CampaignDataProvider;
        }

        $onInit() {
            this.restartDate;
            this.showDateError = false;
            this.selectedCampaignID = this.selectedCampaign;
            this.campaignDataProvider
                .ownerCampaigns(this.currentUser.uid)
                .then((userOwnerCampaigns) => {
                    const campaigns = _.cloneDeep(userOwnerCampaigns);
                    angular.forEach(campaigns, (value) => {
                        if (this.selectedCampaignID || campaigns.length == 1) {
                            //if there is only one campaign, then select that one
                            if (
                                this.selectedCampaignID == value.campaignid ||
                                campaigns.length == 1
                            ) {
                                value.selected = true;
                            }
                        }
                        if (value.campaignstatusid == 1) {
                            this.campaigns.push(value);
                        }
                    });
                    this.getSelectedCampaigns();
                });
        }

        getSelectedCampaigns() {
            const campaigns = [];
            angular.forEach(this.campaigns, (campaign) => {
                if (campaign.selected) {
                    campaigns.push(campaign);
                }
            });
            this.selectedCampaigns = campaigns;
            return campaigns;
        }

        confirm() {
            if (this.step === 1) {
                this.step = 2;
                this.showDateError = false;
                return;
            }

            if (!this.restartDate) {
                this.showDateError = true;
                return;
            }
            this.$mdDialog.hide({
                campaigns: this.getSelectedCampaigns(),
                restart_date: this.restartDate,
            });
        }

        cancel() {
            if (this.step == 2) {
                this.step = 1;
            } else {
                this.$mdDialog.cancel();
            }
        }

        close() {
            this.$mdDialog.cancel();
        }
    },
};

angular
    .module("cancel")
    .component(EssentialsDialogController.selector, EssentialsDialogController);
